import { Node, mergeAttributes } from '@tiptap/core'

export const Category = Node.create({
  name: 'category',

  group: 'block',

  content: 'text*',

  draggable: true,

  isolating: true,

  parseHTML() {
    return [
      {
        tag: 'span'
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ({ node }) => {
      const div = document.createElement('div');
      div.innerHTML = `${node.content.content[0]?.text}`

      return {
        dom: div,
      }
    }
  }
})
